import { z } from 'zod/v4';

const EnvSchema = z.object({
  VITE_FIREBASE_API_KEY: z.string(),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().optional(),
  VITE_FIREBASE_PROJECT_ID: z.string(),
  VITE_FIREBASE_STORAGE_BUCKET: z.string(),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string(),
  VITE_FIREBASE_APP_ID: z.string(),
  VITE_FIREBASE_VAPID_KEY: z.string(),
  VITE_NODE_ENV: z.string(),
  VITE_ENABLE_SIGN_UP_WITH_GOOGLE: z
    .string()
    .optional()
    .default('false')
    .transform((val) => val === 'true'),
  VITE_AUTH_EMULATOR_HOST: z.string().optional(),
  // App Check configuration
  VITE_TURNSTILE_SITE_KEY: z.string().optional(),
  // Rollbar error monitoring
  VITE_ROLLBAR_ACCESS_TOKEN: z.string().optional(),
  // Mixpanel session replay
  VITE_MIXPANEL_TOKEN: z.string().optional(),
});

export type Env = z.infer<typeof EnvSchema>;
const parsedEnv = EnvSchema.safeParse(import.meta.env);

if (!parsedEnv.success && parsedEnv.error) {
  console.error(
    'Invalid environment variables:',
    z.treeifyError(parsedEnv.error),
  );
  throw new Error('Invalid environment variables');
}

export const env = parsedEnv.data;
